import http from '../common/compornents/httpcommon';

class CommonServ {
  getTokuisaki = (params: any) => {
    return http.get('getTokuisakiName/', { params });
  };
}
export default new CommonServ();
